import { useState } from 'react';
import _ from 'lodash';

const useList = (props) => {
  const [dataList, setDataList] = useState(props.data ? props.data : []);

  const onAdd = () => {
    const _dataList = _.cloneDeep(dataList);
    _dataList.push(props.emptyItem ? _.cloneDeep(props.emptyItem) : {});
    setDataList(_dataList);
  };

  const onReset = (list) => {
    const _dataList = [];

    list.forEach((element) => {
      const index = _.findIndex(dataList, { key: element });
      if (index > 0) {
        _dataList.push({
          key: element,
          value: dataList[index].value,
        });
      } else {
        _dataList.push({
          key: element,
          value: element,
        });
      }
    });

    setDataList(_dataList);
  };

  const onDeleteItem = (index) => {
    const _dataList = _.cloneDeep(dataList);
    _.pullAt(_dataList, index);
    setDataList(_dataList);
  };

  const onItemChange = (index, type, value) => {
    const _dataList = _.cloneDeep(dataList);
    _dataList[index][type] = value;
    setDataList(_dataList);
  };

  return {
    dataList,
    setDataList,
    onAdd,
    onDeleteItem,
    onItemChange,
    onReset,
  };
};

export default useList;
